import { Box, Button, ListItem, Skeleton, Typography } from '@mui/material';
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SX_STYLES } from '../../styles/components/listItems/ListProductStyles';
import { SPACING } from '../../constants/Spacing';

const ListProduct = (props) => {
    const [imgLoaded, setImgLoaded] = useState(false);
    const edgeMargin = {
        marginLeft: props.index === 0 ? SPACING.x_large : 0,
        marginRight: props.index === props.arrayLength - 1 ? SPACING.x_large : 0,
        width: props.medium ? '39.2vh' : '100%'
    }
    const edgeMarginDescription = {
        width: props.medium ? null : '94%'
    }
    const imageCover = {
        width: props.small ? '53%' : props.medium ? '70%' : '100%',
        borderTopLeftRadius: props.medium || props.small ? 0 : '1.4vh', 
        borderTopRightRadius: props.medium || props.small ? 0 : '1.4vh', 
    }
    const textWrap = {
        width: props.medium ? '34.5vh' : '32vw',
    }
    return (
        <ListItem
            component={motion.li}
            whileHover={{ y: -6, boxShadow: '0 12px 32px rgba(41,97,231,0.13)' }}
            transition={{ type: 'spring', stiffness: 300, damping: 22 }}
            sx={[SX_STYLES.container, edgeMargin, { cursor: 'pointer' }]}
        >
            <Box sx={SX_STYLES.containerWrapper}>
                {!imgLoaded && (
                    <Skeleton variant='rectangular' animation='wave' sx={{ width: '100%', height: '100%', borderTopLeftRadius: '1.4vh', borderTopRightRadius: '1.4vh' }} />
                )}
                <Box
                    component='img'
                    src={props.image}
                    sx={[SX_STYLES.imageStyle, imageCover, { opacity: imgLoaded ? 1 : 0, transition: 'opacity 0.4s ease' }]}
                    onLoad={() => setImgLoaded(true)}
                />
            </Box>
            <Box sx={[SX_STYLES.containerDescription, edgeMarginDescription]}>
                <Typography sx={[SX_STYLES.title, textWrap]}>{props.title}</Typography>
                <Typography sx={[SX_STYLES.body, textWrap]}>{props.body}</Typography>
                <Box sx={SX_STYLES.buttonContainer}>
                    <Button variant='text' sx={SX_STYLES.button} onClick={props.onClick}>Read more</Button>
                </Box>
            </Box>
            
        </ListItem>
    );
}

export default ListProduct;